import { Reducer } from 'redux';

import { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import { Loki } from './types';

export type SessionAction = SessionConfigureAction;

const initialState: Loki = {
  clientType: '',
  region: '',
};

const reducer: Reducer<Loki, SessionAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.loki;
    default:
      return state;
  }
};

export default reducer;
